import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { isNative } from './capacitor';

/**
 * Must be called once at the very start of the app, before any UI renders.
 * On web this is a no-op so the boot sequence stays the same on all platforms.
 */
export async function notifyAppReady() {
  if (!isNative()) return;
  await CapacitorUpdater.notifyAppReady();
}
